var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Percent = function Percent(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M18.707 6.707a1 1 0 0 0-1.414-1.414l-12 12a1 1 0 1 0 1.414 1.414l12-12ZM5 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0ZM15 17a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Percent;